// synchronous state changes
export default {
  // original, scaled
  setMode(state: ArticleState, mode: string) {
    state.mode = mode
  },

  // originalMetaData, metaData, ingredients
  updateCache(state: ArticleState, cache: ArticleState.cache) {
    state.cache = {
      ...state.cache,
      ...cache,
    }
  },

  // overwrite meta data, keeping original if not overwritten
  updateMetaData(state: ArticleState, metaData: ArticleMetaData) {
    state.metaData = {
      ...state.metaData,
      ...metaData,
    }
  },

  // map of ingredients { id: {}, id: {} } for easy lookup
  setIngredients(state: ArticleState, ingredients: Ingredients) {
    state.ingredients = {
      ...ingredients,
    }
  },

  setScaleLoading(state: ArticleState, newLoading: boolean) {
    state.scaleLoading = newLoading
  },

  setScaleError(state: ArticleState, error: string) {
    state.scaleError = error
  },
}
